// Styled.
import styled from 'styled-components';

export const Themes = styled.div`
  display: flex;
  flex-flow: row;
  padding: 0 var(--xs-padding-horizontal);
`;
